import { EnvironmentOutlined } from '@ant-design/icons';
import { AlgoliaWaterbodyDetail, Waterbody } from '@omniafishing/core';
import _ from 'lodash';
import pluralize from 'pluralize';
import React from 'react';
import { Link } from 'react-router-dom';
import { OmniaUrls } from '../../../../lib/urls';
import { WaterbodyPaths } from '../../../../routes';
import { WaterbodyImg } from '../../../waterbody_img/waterbody_img';
import styles from './waterbody_detail_waterbody_card.less';

interface WaterbodyDetailWaterbodyCardProps {
  distance: number;
  onClick?: () => void;
  waterbody: Waterbody | AlgoliaWaterbodyDetail;
  linkToBoatRampsPage?: boolean;
}

export const WaterbodyDetailWaterbodyCard = (props: WaterbodyDetailWaterbodyCardProps) => {
  const { distance, onClick, waterbody, linkToBoatRampsPage } = props;
  const { fishing_reports_count } = waterbody;

  const states = waterbody.locales.map((l) => l.state.abbr);
  const counties = _.flatten(waterbody.locales.map((l) => l.counties));
  const url = linkToBoatRampsPage
    ? OmniaUrls.waterbody(waterbody, WaterbodyPaths.BOAT_RAMPS)
    : OmniaUrls.waterbody(waterbody);

  return (
    <>
      <div>
        <Link
          to={url}
          className={styles.tileLink}
          onClick={() => {
            onClick?.();
          }}
        >
          <WaterbodyImg waterbody={waterbody} />
        </Link>
      </div>
      <div className={styles.tileText}>
        <Link
          to={url}
          className={styles.tileLink}
          onClick={() => {
            onClick?.();
          }}
        >
          <p className={styles.tileTitle}>{waterbody.primary_name}</p>
        </Link>
        {(states.length > 0 || counties.length > 0) && (
          <p>
            {states.join(', ')}, {counties.join(', ')}
          </p>
        )}

        <div className={styles.tileInfoText}>
          <p>
            <EnvironmentOutlined />
            {distance} miles
          </p>
          <p>
            {fishing_reports_count} fishing {pluralize('report', fishing_reports_count)}
          </p>
        </div>
      </div>
    </>
  );
};
